(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-mini.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-mini.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.drawCard,
  DrawCard = _svs$components$tipse.DrawCard,
  useConditionalWrapper = _svs$components$tipse.useConditionalWrapper;
const ReactIcon = svs.ui.ReactIcon;
const _svs$components$tipse2 = svs.components.tipsen.drawCard.constants,
  DRAW_CARD_ICON_SIZE = _svs$components$tipse2.DRAW_CARD_ICON_SIZE,
  DRAW_STATE = _svs$components$tipse2.DRAW_STATE,
  DRAW_STATE_TEXTS = _svs$components$tipse2.DRAW_STATE_TEXTS;
const _svs$ui$ReactSpeechBu = svs.ui.ReactSpeechBubble,
  SpeechBubble = _svs$ui$ReactSpeechBu.SpeechBubble,
  SpeechBubbleSport3 = _svs$ui$ReactSpeechBu.SpeechBubbleSport3;
const DisabledOverlay = svs.components.tipsen.drawCard.components.DisabledOverlay;
const HorizontalTextAnimation = svs.components.lbUi.HorizontalTextAnimation;
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const DisabledOverlayWrapper = _ref => {
  let children = _ref.children;
  return React.createElement(DisabledOverlay, {
    isMini: true
  }, children);
};
const IconBundle = _ref2 => {
  let icon = _ref2.icon,
    children = _ref2.children,
    hasHiddenAria = _ref2.hasHiddenAria;
  return React.createElement("div", {
    "aria-hidden": Boolean(hasHiddenAria),
    className: "pg_draw_card_mini__icon_bundle"
  }, icon && React.createElement(ReactIcon, {
    icon: icon,
    size: DRAW_CARD_ICON_SIZE.MINI
  }), children);
};
const LiveLabel = () => React.createElement("div", {
  className: "pg_draw_card_mini__live_label"
}, "Live");
const LeftColumn = _ref3 => {
  var _renderDate$charAt;
  let state = _ref3.state,
    regCloseTime = _ref3.regCloseTime;
  if (state === DRAW_STATE.CANCELLED) {
    return React.createElement("div", {
      "aria-label": DRAW_STATE_TEXTS.CANCELLED,
      className: "pg_draw_card_mini__icon_grid"
    }, React.createElement(IconBundle, {
      hasHiddenAria: true
    }, React.createElement(DrawCard.Status, {
      isCancelled: true
    }, DRAW_STATE_TEXTS.CANCELLED)));
  }
  if (state === DRAW_STATE.IS_LIVE) {
    return React.createElement(LiveLabel, null);
  }
  const date = new Date(regCloseTime);
  const isValidDate = !isNaN(date);
  const renderDate = isValidDate ? formatDate(regCloseTime, true, true, false) : regCloseTime;
  const renderDataCapitalized = (renderDate === null || renderDate === void 0 || (_renderDate$charAt = renderDate.charAt(0)) === null || _renderDate$charAt === void 0 ? void 0 : _renderDate$charAt.toUpperCase()) + (renderDate === null || renderDate === void 0 ? void 0 : renderDate.slice(1));
  return React.createElement("div", {
    "aria-label": state === DRAW_STATE.FINISHED ? 'Avslutad' : "Spelstopp: ".concat(renderDataCapitalized),
    className: "pg_draw_card_mini__icon_grid"
  }, React.createElement(IconBundle, {
    hasHiddenAria: true,
    icon: "clock-simple"
  }, React.createElement(DrawCard.RegCloseTime, null, state === DRAW_STATE.FINISHED ? 'Avslutad' : regCloseTime)));
};
const CenterColumn = _ref4 => {
  let currencyCounterUniqueId = _ref4.currencyCounterUniqueId,
    state = _ref4.state,
    netSale = _ref4.netSale;
  if (state === DRAW_STATE.NOT_OPENED) {
    return React.createElement("div", {
      "aria-label": DRAW_STATE_TEXTS.NOT_OPENED,
      className: "pg_draw_card_mini__icon_grid"
    }, React.createElement(IconBundle, {
      hasHiddenAria: true
    }, React.createElement(DrawCard.Status, null, DRAW_STATE_TEXTS.NOT_OPENED)));
  }
  return React.createElement("div", {
    "aria-label": "Oms\xE4ttning: ".concat(currencyFromJupiterString(netSale), " kronor."),
    className: "pg_draw_card_mini__icon_grid"
  }, React.createElement(IconBundle, {
    hasHiddenAria: true,
    icon: "money"
  }, React.createElement(DrawCard.NetSale, {
    currencyCounterUniqueId: currencyCounterUniqueId
  }, netSale)));
};
const RightColumn = _ref5 => {
  let extraMoney = _ref5.extraMoney;
  if (!(extraMoney !== null && extraMoney !== void 0 && extraMoney.amount)) {
    return null;
  }
  if (extraMoney !== null && extraMoney !== void 0 && extraMoney.isGuaranteeJackpot) {
    return React.createElement("div", {
      "aria-label": "En ensam vinnare \xE4r garanterad ".concat(extraMoney.amount, " kronor"),
      className: "pg_draw_card_mini__icon_grid"
    }, React.createElement(IconBundle, {
      hasHiddenAria: true,
      icon: "hot"
    }, React.createElement(HorizontalTextAnimation, {
      classNames: "pg_draw_card_component pg_draw_card_mini__guarantee_jackpot"
    }, "En ensam vinnare \xE4r garanterad ".concat(extraMoney.amount, " kr"))));
  }
  return React.createElement("div", {
    "aria-label": extraMoney.amount,
    className: "pg_draw_card_mini__icon_grid"
  }, React.createElement(IconBundle, {
    hasHiddenAria: true,
    icon: "hot"
  }, React.createElement(DrawCard.ExtraAmount, null, extraMoney.amount)));
};
const DrawCardMini = _ref6 => {
  let branding = _ref6.branding,
    className = _ref6.className,
    competitionName = _ref6.competitionName,
    uniqueId = _ref6.uniqueId,
    extraMoney = _ref6.extraMoney,
    _ref6$icon = _ref6.icon,
    icon = _ref6$icon === void 0 ? 'game-sport' : _ref6$icon,
    league = _ref6.league,
    netSale = _ref6.netSale,
    regCloseTime = _ref6.regCloseTime,
    state = _ref6.state,
    titleElement = _ref6.titleElement;
  const classNames = ['pg_draw_card_mini'];
  className && classNames.push(className);
  const ConditionalDisabledOverlayWrapper = useConditionalWrapper(DisabledOverlayWrapper, {
    skip: state !== DRAW_STATE.TEMPORARY_CLOSED
  });
  return React.createElement(ConditionalDisabledOverlayWrapper, null, React.createElement(DrawCard, {
    branding: branding,
    className: classNames.join(' ')
  }, React.createElement("div", {
    "aria-label": "Omg\xE5ng: ".concat(titleElement).concat(competitionName ? ", ".concat(competitionName) : ''),
    className: "pg_draw_card_mini__section"
  }, React.createElement(DrawCard.Title, {
    hasHiddenAria: true,
    icon: icon,
    iconSize: DRAW_CARD_ICON_SIZE.MINI
  }, titleElement), competitionName ? React.createElement(SpeechBubble, {
    size: "100"
  }, React.createElement(SpeechBubbleSport3, null, competitionName)) : React.createElement(DrawCard.League, {
    hasHiddenAria: true
  }, league)), React.createElement("div", {
    className: "pg_draw_card_mini__section"
  }, React.createElement(LeftColumn, {
    regCloseTime: regCloseTime,
    state: state
  }), React.createElement(CenterColumn, {
    currencyCounterUniqueId: uniqueId,
    netSale: netSale,
    state: state
  }), React.createElement(RightColumn, {
    extraMoney: extraMoney
  }))));
};
setGlobal('svs.components.tipsen.drawCard.DrawCardMini', DrawCardMini);

 })(window);